const checkoutErrorMapper = require('../../../checkout/components/checkoutwizard/atmmapper/checkout-error-mapper');

function IdVerificationDirective(shopperService, currentUserService, atm, $location) {
  return {
    restrict: 'E',
    template: require('./id-verification-template.html'),
    scope: {
      wizzardStep: '@',
      isGuest: '=?',
      idVerificationDetails: '=?',
      isVerificationAlertShown: '=?',
      deliveryType: '=?',
      idVerificationSuccess: '&',
      detailsUpdated: '&',
      initVerificationAlert: '&',
      verificationShownAlert: '&'
    },
    link(scope) {
      scope.isLoading = false;
      scope.errorMsg = '';
      scope.verificationSummary = scope.idVerificationDetails
        ? {
            FirstName: scope.idVerificationDetails.FirstName,
            LastName: scope.idVerificationDetails.LastName,
            DateOfBirth: scope.idVerificationDetails.DateOfBirth,
            Status: scope.idVerificationDetails.Status
        }
        : {
            FirstName: '',
            LastName: '',
            Status: '',
            DateOfBirth: ''
        };

      if (scope.idVerificationDetails.Status == 'ReadyToUpdate' || scope.idVerificationDetails.Status == 'AgeNotVerified') {
        atm.push({ errorType: 'id verification', errorMessage: scope.idVerificationDetails.CartIdVerificationFailedMessage.Title }, checkoutErrorMapper)
      }

      scope.onInitIdVerification = function () {
        scope.isLoading = true;
        scope.initVerificationAlert();
        let location = $location.absUrl();
        if (location.includes('?')); {
          location = location.split('?')
          location = location[0];
        }
        const url = `${location}/idverified`;
        shopperService.initIdVerification(url).then((res) => {
          if (res.Success) {
            scope.isLoading = false;
            window.location.href = res.ResumeUrl; 
          }
        });
      };

      scope.onUpdateDetails = function () {
        scope.isLoading = true;
        shopperService.updateMemberDetails().then((res) => {
          scope.isLoading = false;
          if (res.Success) {
            scope.errorMsg = '';
            scope.detailsUpdated();
          } else {
            scope.errorMsg = res.ErrorMessage;
            atm.push({ errorType: 'id verification', errorMessage: scope.errorMsg }, checkoutErrorMapper)
          }
        });
      };

      scope.openAgeCheckInfo = function () {
        window.open('https://bws.com.au/help/delivery-nsw');
      };

      if (currentUserService.currentUser.isIdVerified) {
        scope.verificationSummary = {
          FirstName: currentUserService.currentUser.FirstName,
          LastName: currentUserService.currentUser.LastName,
          DateOfBirth: currentUserService.currentUser.DateOfBirth,
          Status: 'Completed'
        };
        scope.idVerificationSuccess();
      } else if (scope.verificationSummary.Status === 'Completed') {
        scope.idVerificationSuccess();
      } else if (!scope.verificationSummary.Status) {
        shopperService.getCheckoutIdVerificationDetails().then((res) => {
          scope.verificationSummary = res;
          if (res.Status === 'Completed') {
            if(currentUserService.currentUser.isIdVerified){
              scope.idVerificationSuccess();
            } else{
              scope.verificationSummary= {
                FirstName: currentUserService.currentUser.FirstName,
                LastName: currentUserService.currentUser.LastName,
                DateOfBirth: currentUserService.currentUser.DateOfBirth,
                Status: null
              };  
              scope.verificationShownAlert();            
            }        
          } else {
            if(!scope.isVerificationAlertShown && scope.deliveryType === 'ASAP'){
              scope.verificationShownAlert();
            }
          }
        });
      }
    }
  };
}

module.exports = IdVerificationDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/id-verification/id-verification-directive.js
 **/